import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿En qué formato vienen las planillas?',
  a: 'Vienen en Excel, Google Sheets, Word y PDF. Están listas para usar directamente o para modificar según tus necesidades.'
}, {
  q: '¿Son editables y personalizables?',
  a: 'Sí, 100%. Podés agregar tu logo, cambiar colores, modificar los textos y adaptar los campos a tu forma de trabajo.'
}, {
  q: '¿Sirven para presentar en obras sociales?',
  a: 'Totalmente. Incluyen los campos, formatos y terminología que exigen las auditorías médicas para aprobar tratamientos.'
}, {
  q: '¿Necesito algún software especial?',
  a: 'No, solo los programas básicos de Office (Word, Excel) o una cuenta gratuita de Google Drive para usar Sheets y Docs.'
}, {
  q: '¿Sirve si recién me recibo y no tengo experiencia?',
  a: 'Es ideal. Te da la estructura administrativa y profesional que no te enseñan en la facultad, ahorrándote meses de prueba y error.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'Acceso inmediato por email tras el pago. Descargás todo a tu computadora o lo guardás en tu Drive para tenerlo siempre a mano.'
}, {
  q: '¿Puedo imprimirlas y usarlas en papel?',
  a: 'Sí, todas las planillas están diseñadas en formato A4, listas para imprimir si preferís llevar el registro en papel.'
}, {
  q: '¿Qué pasa si no me sirven?',
  a: 'Tenés 30 días de garantía total. Si sentís que no se adaptan a tu consultorio, te devolvemos el dinero sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-24 bg-slate-50" data-id="element-110">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
        <div className="text-center mb-10 md:mb-16" data-id="element-112">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-113">
            Preguntas frecuentes
          </h2>
          <div className="w-24 h-1 bg-brand-accent mx-auto rounded-full" data-id="element-114"></div>
        </div>

        <div className="space-y-4" data-id="element-115">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm" data-id="element-116">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-117">
                <span className="font-bold text-slate-900 pr-4" data-id="element-118">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-accent transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-119" />
              </button>
              <AnimatePresence data-id="element-120">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-121">
                    <div className="px-6 pb-5 text-slate-600" data-id="element-122">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}